import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { MorphemeMnemonicsPanelContext } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._views.grapheme.mnemonics._components.panel-content._context";
import { Icon } from "@-/dev.improve.haniverse.components.ui.icon";
import { Pressable, View } from "@-/com.npmjs.react-native";

export function MorphemeMnemonicsPronunciationViewTabEditButton() {
  const [isEditing, setIsEditing] = useContextSelectors(
    MorphemeMnemonicsPanelContext,
    (c) => c.isEditing,
    (c) => c.setIsEditing,
  );

  return (
    <View className="shrink-0 flex-row items-center">
      <Pressable
        accessibilityLabel="Edit pronunciation mnemonic"
        accessibilityRole="button"
        hitSlop={12}
        onPress={() => setIsEditing((prev) => !prev)}
      >
        <Icon
          className="text-muted-foreground"
          name={isEditing ? "LuCheck" : "LuPenLine"}
          size={16}
        />
      </Pressable>
    </View>
  );
}
